import type { SVGProps } from 'react';

const SvgClockAndDelay = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="clock-and-delay">
      <path d="M16 .09A15.91 15.91 0 1 0 31.91 16 15.93 15.93 0 0 0 16 .09Zm0 30.32A14.41 14.41 0 1 1 30.41 16 14.42 14.42 0 0 1 16 30.41Z" />
      <path d="M16.75 5.29h-1.5v11.45a.76.76 0 0 0 .75.75h10.25V16h-9.5Z" />
    </g>
  </svg>
);

export default SvgClockAndDelay;
